export function sliiderWrapper() {
  // Check if Swiper is available.
  if (typeof Swiper === 'undefined') {
    console.warn('Swiper is not loaded yet, waiting for swiperLoaded event');
    // Listen to the Swiper loading event.
    document.addEventListener('swiperLoaded', function() {
      initSliderWrapper();
    });
    return;
  }

  initSliderWrapper();
}

function initSliderWrapper() {
  document.querySelectorAll(".wp-block-gallery.slider-wrapper").forEach((gallery, index) => {
    // Check if the slider has already been initiated.
    if (gallery.classList.contains('swiper-initialized')) {
      return;
    }

    gallery.classList.add("swiper");
    let wrapperDiv = document.createElement("div");
    wrapperDiv.classList.add("swiper-wrapper");
    gallery.querySelectorAll("figure").forEach((slide) => {
      slide.classList.add("swiper-slide");
      wrapperDiv.appendChild(slide);
    });
    gallery.innerHTML = "";
    gallery.appendChild(wrapperDiv);
    let prevButton = document.createElement("div");
    let nextButton = document.createElement("div");
    let prevId = `swiper-button-prev-${index}`;
    let nextId = `swiper-button-next-${index}`;
    prevButton.id = prevId;
    nextButton.id = nextId;
    prevButton.classList.add("swiper-button-prev");
    nextButton.classList.add("swiper-button-next");
    gallery.appendChild(prevButton);
    gallery.appendChild(nextButton);

    let swiper = new Swiper(gallery, {
      slidesPerView: 4,
      spaceBetween: 0,
      loop: true,
      navigation: {
        nextEl: `#${nextId}`,
        prevEl: `#${prevId}`,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        360: {
          slidesPerView: 1,
        },
        576: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        },
        1200: {
          slidesPerView: 4,
        },
      },
      on: {
        init: function () {
          gallery.classList.add("swiper-initialized");
        },
      },
    });
  });
}

// Share the function globally for callback with PHP.
window.initSliderWrapper = initSliderWrapper;
